module.exports = __webpack_public_path__ + "static/media/CeraPro-Medium.eff263c1.woff2";